import { getAppName, getPlatform } from '@/lib/utils';
import { IEventUnion } from '@/types/analytics';
import { ELocalStorageKey } from '@/types/common';
import * as amplitude from '@amplitude/analytics-browser';

amplitude.init(
  import.meta.env.VITE_AMPLITUDE_API_KEY || '',
  localStorage.getItem(ELocalStorageKey.UserId) ?? undefined,
  {
    serverUrl: import.meta.env.VITE_AMPLITUDE_SERVER_URL || '',
  },
);
export const logEvent = (event: IEventUnion) => {
  const userId = localStorage.getItem(ELocalStorageKey.UserId);
  const passportId = localStorage.getItem(ELocalStorageKey.PassportId);
  const eventName = event.event;
  if (userId) {
    event.userId = userId;
  }
  if (passportId) {
    event.passportId = passportId;
  }
  event.projectId = 'AITU';
  event.fork_id = import.meta.env.VITE_NAME || getAppName();
  event.platform = getPlatform();
  // eslint-disable-next-line no-console
  console.log('pushGaEvent', event);
  amplitude.track(eventName, event);
};
